"use client";

import { CheckCircle2 } from "lucide-react";
import ResumeUploader from "../ResumeUploader";

// Anchor for "Tailor my resume" buttons further down the page.
export const UPLOADER_ID = "get-started";

const HIGHLIGHTS = [
  "Tailored to each job",
  "Live job match score",
  "Refine each section with AI over multiple rounds",
  "Free to start",
];

export default function HeroSection() {
  return (
    <section className="py-10 px-4 sm:px-6 lg:px-8">
      <div className="max-w-7xl mx-auto text-center">
        <div className="mb-10 text-center">
          <h1 className="text-4xl md:text-6xl font-extrabold text-gray-900 mb-6 leading-tight">
            Get Hired Faster with
            <br />
            <span className="bg-gradient-to-r from-blue-600 to-purple-600 bg-clip-text text-transparent">
              Job Tailored Resumes
            </span>
          </h1>

          <p className="text-lg md:text-xl text-gray-700 max-w-2xl mx-auto mb-6 leading-relaxed">
            Upload your resume, paste the job description, and get a resume rewritten for that job
            that passes ATS screening.
          </p>

          <ul className="flex flex-wrap justify-center gap-x-6 gap-y-2 text-sm text-gray-700">
            {HIGHLIGHTS.map((item) => (
              <li key={item} className="inline-flex items-center gap-1.5">
                <CheckCircle2 className="h-4 w-4 text-green-600" />
                {item}
              </li>
            ))}
          </ul>
        </div>

        <div id={UPLOADER_ID} className="scroll-mt-24">
          <ResumeUploader />
        </div>
      </div>
    </section>
  );
}
